/**
 * Courtney's own words, carried over from the old Index.cshtml unchanged. Paragraphs are
 * segmented so the original <strong>/<em> emphasis survives without embedding markup in data.
 */
export type Segment = {
  text: string;
  emphasis?: 'strong' | 'em';
};

export const storyParagraphs: Segment[][] = [
  [
    { text: 'Hello! My name is Courtney and ' },
    { text: 'I have a passion for working with children.', emphasis: 'strong' },
    {
      text:
        ' As a young girl in high school, I spent a substantial amount of time caring for babies and' +
        ' young children as a babysitter. After high school, I transitioned into teaching at preschools' +
        ' and have since acquired an immense amount of experience in the industry as a teacher. In my' +
        ' long career as a caregiver, I also spent some time as a nanny caring for a newborn baby until' +
        ' their first birthday. To this day, I still help that family with babysitting and the child I' +
        ' looked after has grown up healthy and smart!',
    },
  ],
  [
    {
      text:
        'Going back to a particular memory of the first teaching job I had, I remember that they asked' +
        ' me to lead a different classroom for a day. I was asked to teach the children about ducks and' +
        ' why they have webbed feet. I drew a picture on the board to illustrate my point, and the' +
        ' feeling I got when I saw their faces light up when they understood what I was talking about' +
        ' was amazing. I was teaching them something they had never learned before and they understood it!',
    },
  ],
];

export const pullQuote: Segment[] = [
  { text: 'I would ' },
  { text: 'love', emphasis: 'em' },
  { text: " the opportunity to light up your child's eyes and teach them about the world." },
];
